import { cx } from '@linaria/core';
import { useRef, useCallback } from 'react';
import { IconButton, Search, CloseButton } from '@ui/kit';
import { SearchIcon } from '@ui/kit/icons';
import { useToggleState, useClickOutsideListener, useKeyListener } from '@utils/react';
import { closeButton, searchWrapper } from './search.mobile.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function MobileSearch(props) {
  const searchWrapperRef = useRef(null);
  const searchInputRef = useRef(null);
  const [showSearch, actions] = useToggleState();
  const onOpen = useCallback(() => {
    actions.enable();
    searchInputRef.current?.focus();
  }, [actions]);
  const onClose = useCallback(() => {
    actions.disable();
    searchInputRef.current?.blur();
  }, [actions]);
  useClickOutsideListener(onClose, searchWrapperRef, {
    disabled: !showSearch
  });
  useKeyListener(evt => {
    if (evt.key === "Enter") {
      onClose();
    }
  }, {
    disabled: !showSearch
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(IconButton, {
      icon: /*#__PURE__*/jsx(SearchIcon, {
        height: "20"
      }),
      label: "\xC5bn s\xF8gepanel",
      onClick: onOpen
    }), /*#__PURE__*/jsxs("div", {
      className: cx(searchWrapper, showSearch && "visible"),
      children: [/*#__PURE__*/jsx(Search, {
        ref: searchWrapperRef,
        inputRef: searchInputRef,
        placeholder: props.label,
        "aria-label": props.label,
        onQueryChange: props.onQueryChange,
        debounceMs: 350,
        theme: "local"
      }), /*#__PURE__*/jsx(CloseButton, {
        className: closeButton,
        label: "Luk s\xF8gepanel",
        onClose: onClose
      })]
    })]
  });
}

export { MobileSearch };
//# sourceMappingURL=search.mobile.js.map
